import React, { useState, useEffect, useRef } from "react";
import ChronologyData from "./data/chronologyData.js";

const panels = [
    "1771 - 1790",
    "1791 - 1800",
    "1801 - 1810",
];

const Chronology = () => {
    const [activePanels, setActivePanels] = useState([]);
    const [filteredEntries, setFilteredEntries] = useState({});
    const contentRef = useRef(null);

    const togglePanel = (panel) => {
        setActivePanels((prevPanels) =>
            prevPanels.includes(panel)
                ? prevPanels.filter((p) => p !== panel)
                : [...prevPanels, panel]
        );
    };

    useEffect(() => {
        setActivePanels(panels);
    }, []);

    useEffect(() => {
        if (!contentRef.current) return;
    
        const newFilteredEntries = {};
    
        panels.forEach((panel) => {
            if (!activePanels.includes(panel)) return;
    
            const [startYear, endYear] = panel.split(" - ").map(Number);
            const tableRows = contentRef.current.querySelectorAll("table tr");
    
            let lastKnownYear = null;
            const matchingRows = [];
    
            Array.from(tableRows).forEach((row) => {
                const yearCell = row.querySelector("td");
                if (!yearCell) return;
    
                const yearText = yearCell.textContent.trim();
                const year = parseInt(yearText, 10);
    
                if (!isNaN(year)) {
                    lastKnownYear = year;
                }
    
                // Use lastKnownYear for filtering
                if (lastKnownYear && lastKnownYear >= startYear && lastKnownYear <= endYear) {
                    matchingRows.push(row.cloneNode(true));
                }
            });
    
            if (matchingRows.length > 0) {
                const wrapper = document.createElement("table");
                wrapper.className = "table table-bordered";
                wrapper.style.border = "1px solid #ddd";
                wrapper.style.borderCollapse = "collapse";
                wrapper.style.width = "100%";
                wrapper.style.marginBottom = "20px";
            
                const tbody = document.createElement("tbody");
            
                matchingRows.forEach((row) => {
                    // Apply border to each cell inside the row
                    const cells = row.querySelectorAll("td, th");
                    cells.forEach((cell) => {
                        cell.style.border = "1px solid #ddd";
                        cell.style.padding = "8px";
                        cell.style.verticalAlign = "top";
                    });
            
                    tbody.appendChild(row);
                });
            
                wrapper.appendChild(tbody);
                newFilteredEntries[panel] = wrapper.outerHTML;
            }
            
        });
    
        setFilteredEntries(newFilteredEntries);
    }, [activePanels]);
    

    return (
        <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
            {panels.map((panel) => {
                const panelId = `c${panel.substring(0, 4)}`;
                const headingId = `h${panel.substring(0, 4)}`;
                const isActive = activePanels.includes(panel);

                return (
                    <div key={panel} className="panel panel-default panel-box">
                        <div className="panel-heading" role="tab" id={headingId}>
                            <h4 className="panel-title">
                                <button
                                    className="btn panel-title-btn"
                                    onClick={() => togglePanel(panel)}
                                >
                                    <strong>{panel}</strong>
                                </button>
                            </h4>
                        </div>
                        {isActive && (
                            <div id={panelId} className="panel-collapse in" role="tabpanel">
                                <div className="panel-body">
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: filteredEntries[panel] || "",
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}

            <div ref={contentRef} style={{ display: "none" }}>
                <ChronologyData />
            </div>
        </div>
    );
};

export default Chronology;